import { NgModule } from '@angular/core';
import { WrapperComponent } from './_components/wrapper/wrapper.component';
import { CommonModule } from '@angular/common';
import { AppsSharedModule } from 'base';

@NgModule({
  declarations: [WrapperComponent],
  imports: [CommonModule, AppsSharedModule],
  exports: [WrapperComponent],
})
export class LayoutModule {}
